/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Add_Other_OptionInputs */

const en_admin_questionnaire_editor_add_other_option = /** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add “Other” option`)
};

const nl_admin_questionnaire_editor_add_other_option = /** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optie “Overig” toevoegen`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const de_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const es_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const it_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/** @type {(inputs: Admin_Questionnaire_Editor_Add_Other_OptionInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_add_other_option = en_admin_questionnaire_editor_add_other_option;

/**
* | output |
* | --- |
* | "Add “Other” option" |
*
* @param {Admin_Questionnaire_Editor_Add_Other_OptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_add_other_option = /** @type {((inputs?: Admin_Questionnaire_Editor_Add_Other_OptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Add_Other_OptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_add_other_option(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_add_other_option(inputs)
	return ro_admin_questionnaire_editor_add_other_option(inputs)
});
export { admin_questionnaire_editor_add_other_option as "admin.questionnaire_editor.add_other_option" }